import { AbstractGetAllStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ImpiantiTermiciActions";
import { ApparecchioCategory } from "../generated";

class ApparecchioCategoriesStore extends AbstractGetAllStore<ApparecchioCategory> {
    constructor() {
        super(x => x.id.toString());
        Dispatcher
            .onfunction(Actions.getApparecchioCategories, result => this.setAll(result))
    }

    public useAll = () => this.useAllWithAction(() => Actions.getApparecchioCategories());

}

export default new ApparecchioCategoriesStore()
